// Module-scoped endpoint paths for offerings (listing, filters, bookmark, notify,
// invest-form). Property detail lives in the sibling property sub-module.

export const OFFERINGS_ENDPOINTS = {
  OFFERINGS: '/api/offerings',
  OFFERINGS_FILTERS: '/api/offerings/filters',
  BOOKMARK: '/api/offerings/{offeringId}/bookmark',
  NOTIFY: '/api/offerings/{offeringId}/notify',
} as const
